<template>
    <div>
        <el-dialog
            :title="$t('SET_WHITE_LIST')"
            :visible.sync="whiteListVisible"
            width="40%"
            :close-on-click-modal="false"
            :before-close="closeWhiteList"
        >
            <span slot="title">
                <span class="font18">{{ $t('SET_WHITE_LIST') }}</span>
                <i class="el-icon-warning info-cls" />
                <span style="font-size: 12px; color: #fd349c">
                    {{ $t('WHITE_LIST_TIP') }}
                </span>
            </span>
            <!-----------------新增--------------start----------->
            <div class="right">
                <el-popover placement="left-start" width="300" v-model="addVisible" trigger="manual">
                    <el-form :model="addWhiteForm" :rules="rules" ref="addWhiteFormRef">
                        <el-form-item prop="email">
                            <el-input
                                v-model="addWhiteForm.email"
                                :placeholder="$t('ENTER_WHITE_LIST_PLACEOLDER')"
                                type="text"
                                clearable
                                style="font-size: 12px"
                                @keyup.enter.native="submitForm('addWhiteFormRef')"
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="btn-cls">
                            <el-button size="mini" @click="closeAdd" class="cancel-btn" style="font-size: 12px">{{
                                $t('btn_cancel')
                            }}</el-button>
                            <el-button class="wl-green" size="mini" @click="submitForm('addWhiteFormRef')" style="font-size: 12px">
                                {{ $t('btn_confirm') }}</el-button
                            >
                        </el-form-item>
                    </el-form>
                    <el-button slot="reference" class="wl-green" plain @click="showAdd" style="font-size: 12px" icon="el-icon-plus">{{
                        $t('COMMON_ADD')
                    }}</el-button>
                </el-popover>
            </div>
            <!-------------------------新增--------------end----------->
            <el-table :data="tableData" style="width: 100%">
                <el-table-column :label="$t('WHITE_LIST')">
                    <template slot-scope="scope">
                        <i class="el-icon-message"></i>
                        <el-input
                            v-model="scope.row.email"
                            clearable
                            v-if="showEdit == 'email' + scope.$index"
                            class="email-input-cls"
                            type="text"
                            @change="editEmail(scope.$index, scope.row)"
                            @keyup.enter.native="editEmail(scope.$index, scope.row)"
                        ></el-input>
                        <span style="margin-left: 10px" v-else>{{ scope.row.email }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('TABLE_HEADER_Action')">
                    <template slot-scope="scope">
                        <i class="el-icon-edit-outline wl-icon-edit" aria-hidden="true" @click="handleEdit(scope.$index, scope.row)"></i>

                        <el-popconfirm
                            :title="$t('WHITE_LIST_DELE_WARNING')"
                            placement="top"
                            @confirm="handleDelete(scope.$index, scope.row)"
                        >
                            <i style="margin-left: 10px" class="el-icon-delete wl-icon-delete" slot="reference"></i>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'
export default {
    name: 'whiteList',
    props: {
        whiteListVisible: Boolean
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite'
        })
    },
    data() {
        var validWhite = (rule, value, callback) => {
            if (!/^@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/.test(value)) {
                // 邮箱校验
                return callback(new Error(this.$t('FORM_VALIDATE_EMAIL')))
            } else {
                callback()
            }
        }
        return {
            addVisible: false,
            showEdit: '',
            addWhiteForm: {
                email: ''
            },
            tableData: [],
            whiteList: [],
            operatingFlag: false,
            rules: {
                email: [
                    { required: true, message: this.$t('ENTER_WHITE_LIST'), trigger: 'blur' },
                    { validator: validWhite, trigger: ['blur', 'change'] }
                ]
            }
        }
    },
    mounted() {
        this.queryWhiteList()
    },
    methods: {
        // 查询白名单
        async queryWhiteList() {
            const res = await API.clientUser.getSiteConfig({ param: this.getSite.siteId })
            if (res.code == '1') {
                if (res.data.downloadWhiteList == '' || res.data.downloadWhiteList == null) {
                    this.tableData = []
                    return
                }
                this.whiteList = res.data.downloadWhiteList.split(',')
                let tempList = []
                this.whiteList.forEach((item) => {
                    let temp = {
                        email: item
                    }
                    tempList.push(temp)
                })
                this.tableData = tempList
            } else {
                this.$message.error(this.$t(res.code))
            }
        },
        //设置白名单
        async setWhiteList(whiteList) {
            const res = await API.clientUser.setWhiteList({ siteId: this.getSite.siteId, downloadWhiteList: whiteList })
            if (res.code == '1') {
                this.$message.success(this.$t('msg_success'))
                this.addVisible = false
                this.queryWhiteList()
            } else {
                this.$message.error(this.$t(res.code))
            }
        },
        // 关闭白名单窗口
        closeWhiteList() {
            this.$parent.closeWhiteList()
        },
        // 显示新增白名单气泡
        showAdd() {
            if (this.operatingFlag) {
                this.$message.error(this.$t('OPERATE_ING_WARNING'))
            } else {
                this.addVisible = true
                this.operatingFlag = true
                this.$refs['addWhiteFormRef'].resetFields()
            }
        },
        closeAdd() {
            this.addVisible = false
            this.operatingFlag = false
        },
        // 新增白名单
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (this.whiteList.indexOf(this.addWhiteForm.email) != -1) {
                    this.$message.error(this.$t('EMAIL_IS_EXIST'))
                    return false
                } else if (valid) {
                    let whiteStr = this.addWhiteForm.email
                    this.tableData.forEach((item) => {
                        whiteStr += ',' + item.email
                    })
                    this.setWhiteList(whiteStr)
                    this.whiteList.unshift(this.addWhiteForm.email)
                    this.operatingFlag = false
                } else {
                    this.$message.error(this.$t('msg_error'))
                    return false
                }
            })
        },
        // 修改白名单--邮箱可修改
        handleEdit(index, row) {
            if (this.operatingFlag) {
                this.$message.error(this.$t('OPERATE_ING_WARNING'))
            } else {
                this.showEdit = 'email' + index
                this.operatingFlag = true
            }
        },
        // 修改白名单
        editEmail(index, row) {
            let [...copyList] = this.whiteList
            copyList.splice(index, 1)
            if (row.email == null || row.email == '') {
                this.$message({
                    showClose: true,
                    message: this.$t('ENTER_WHITE_LIST'),
                    type: 'error'
                })
                return
            } else if (!/^@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/.test(row.email)) {
                this.$message({
                    showClose: true,
                    message: this.$t('FORM_VALIDATE_EMAIL'),
                    type: 'error'
                })
                return
            } else if (copyList.indexOf(row.email) != -1) {
                this.$message({
                    showClose: true,
                    message: this.$t('EMAIL_IS_EXIST'),
                    type: 'error'
                })
                return
            } else {
                this.showEdit = ''
                this.whiteList[index] = row.email
                this.setWhiteList(this.whiteList.join(','))
                this.operatingFlag = false
            }
        },
        // 删除白名单
        handleDelete(index, row) {
            if (this.operatingFlag) {
                this.$message.error(this.$t('OPERATE_ING_WARNING'))
            } else {
                this.whiteList.splice(index, 1)
                this.setWhiteList(this.whiteList.join(','))
            }
        }
    }
}
</script>

<style>
.el-popover .el-popconfirm .el-popconfirm__action .el-button {
    border: 1px solid #ccced2;
    border-radius: 5px;
    font-size: 12px;
    height: 30px;
    padding: 5px 10px;
}
.el-popover .el-popconfirm .el-popconfirm__action .el-button:nth-child(1) {
    background-color: #fff;
    color: #333333;
}
.el-popover .el-popconfirm .el-popconfirm__action .el-button:nth-child(2) {
    background: #00338d;
    color: #fff;
}
</style>
<style scoped>
.font18 {
    font-size: 18px;
}
.right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: -15px 0 5px 0;
    align-items: center;
}
.btn-cls {
    text-align: right;
    margin: 10px 0 0;
}
.edit-cls {
    margin-right: 10px;
    font-size: 12px;
}
.del-cls {
    font-size: 12px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin: 15px 0 0;
}
.email-input-cls {
    width: 180px;
    margin-left: 10px;
}
.info-cls {
    color:#fd349c;
    margin-left: 4px;
}
</style>
